import Axios from './base';

export const GetAlerts = () => Axios().get('Alerts')
export const GetAlertsPaginated = (params) => Axios().get('Alerts/Paginated', { params })
export const GetAlertById = (id) => Axios().get('Alerts/Item/' + id)
export const CreateAlerts = (entity) => Axios().post('Alerts', entity)
export const DeleteAlert = (id) => Axios().delete('Alerts/' + id)
export const GetUsers = (type = 'NONE') => Axios().get('Alerts/Users/' + type)
export const DownloadAlerts = (entity) => Axios().post('Alerts/Download', entity)
export const SendEmail = (entity) => Axios('Email Sent').post('Alerts/Email', entity)
export const NotifyLostCard = ()=> Axios().get('/Alerts/RequestLostCard' )
export const SendInvite = (entity) => Axios('Invite Sent').post('Waitlist/Invite', entity)
export const GetAdminUsers = () => Axios().get('Alerts/Admins')
